/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageFile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import OpenInNewTabAction from './OpenInNewTabAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageFile({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/ImageFile"
  
}) {
let documentPreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'document',
path: 'preview_url',
})
  return (<React.Fragment
>
<div
  data-testid="ImageFile.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<img
  data-testid="ImageFile.Image"
  data-view-path={viewPath}
 alt={""}
 src={documentPreviewUrlValueData}
 className={`views-block ${styles.Image}`}
/>
</div>
<OpenInNewTabAction
  viewPath={`${viewPath}/OpenInNewTabAction`}
/>
{children}
</React.Fragment>)
}